import { useState, useEffect } from 'react'
import { debounce } from 'lib/debounce'

export const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const debouncedHandler = debounce(onWindowResize, 50)

  useEffect(() => {
    window.addEventListener('resize', debouncedHandler)

    return () => window.removeEventListener('resize', debouncedHandler)
  })

  function onWindowResize() {
    setWidth(window.innerWidth)
  }

  return width
}
